webpackJsonp([28499843750616],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/careers-c-3-amd-qw-vaezvcd-rr-rfj-ic-rx.json":
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"id":"c3AmdQwVAEZVCDRrRfjIcRx","title":"No open positions at this time","description":{"description":"If you would like to submit a resume and cover letter, please share with admin@contraline.com"},"responsibilities":null,"criteria":null,"aboutContraline":{"aboutContraline":"Contraline is a clinical-stage biotechnology company focused on innovation in male reproductive health. The company is advancing both hormonal and non-hormonal approaches to expand contraceptive options for men and couples globally.\n\nFollowing its recently completed Series B financing, Contraline is entering a pivotal stage of growth as it advances toward late-stage clinical development, regulatory milestones, expanded manufacturing, and future product launch."}}}

/***/ })

});


// WEBPACK FOOTER //
// path---careers-c-3-amd-qw-vaezvcd-rr-rfj-ic-rx-419c918642e05755a3ea.js